import React, { useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import FinPayRollPopUP from "./FinPayRollPopUP";
import nodeinstance from "../../../../nodeInstance";

export default function FinListPayRoll({
  token,
  titles = [],
  list = [],
  updateData,
}) {
  const styles = {
    container: {
      position: "relative",
      width: "200px",
    },
    input: {
      width: "100%",
      height: "35px",
      padding: "10px",
      paddingRight: "30px", // Space for the icon
      fontSize: "16px",
      border: "1px solid #ccc",
      borderRadius: "3px",
      outline: "none",
    },
    tickIcon: {
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "18px",
      color: "green",
      cursor: "pointer",
    },
  };
  const [Popup, setPopUp] = useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const [listData, setListData] = useState();

  const [APIkey, setAPIkey] = useState("");
  const [searchData, setSearchData] = useState([]);

  // const token = localStorage.getItem("nodeToken");

  const onIconClick = async () => {
    try {
      const response = await nodeinstance.get(
        `/atm-payroll/payroll/${APIkey}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSearchData(response.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(searchData?.data || []);

  const apiCall = () => {
    onIconClick();
  };
  const onClearResponse = () => {
    setSearchData([]);
    setAPIkey("");
  };
  const handleSearchData = (e) => {
    setAPIkey(e.target.value);
  };
  console.log("The click to be seen in the console page");
  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => {
              onClearResponse();
            }}
          >
            <p>Clear filter</p>
          </button>
          <div style={styles.container}>
            <input
              type="text"
              placeholder="Enter text here"
              style={styles.input}
              value={APIkey}
              onChange={(e) => {
                handleSearchData(e);
              }}
            />
            <span
              style={styles.tickIcon}
              onClick={() => {
                onIconClick();
              }}
            >
              ✔️
            </span>
          </div>
        </div>

        <CountPerPage />
        <div className="relative bg-white">
          <div className="overflow-x-auto max-h-[70vh] ">
            <div className="sticky top-0 z-10 bg-white min-w-[1750px]">
              <div className="grid grid-cols-table-finPayRoll gap-5 p-6 text-center">
                {titles.map((t, index) => (
                  <p key={index} className="font-semibold uppercase">
                    {t}
                  </p>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-table-finPayRoll gap-5 p-6 bg-white text-center">
              {list?.isLoading && (
                <LoadingWithLable className="col-span-full" />
              )}
              {!list?.isLoading && <NoDataFound />}
              {!list?.isLoading &&
                currentList.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_id || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.name || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.client || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_provider || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_expiry_date_g || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.mobile_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.account_opened_by || "-"}
                      />
                    </p>
                    <button
                      className={
                        "px-2 rounded-md  bg-green-500 text-white text-xs p-2 h-8"
                      }
                      onClick={() => {
                        setPopUp(true);
                        setListData(list);
                      }}
                    >
                      change PayRoll category
                    </button>
                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
        <Pagination />
      </div>
      {Popup ? (
        <FinPayRollPopUP
          list={listData}
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Upload Border Number"}
          url={"/atm-payroll/updateBankDetail_category"}
          callBack={apiCall}
          token={token}
        />
      ) : (
        ""
      )}
    </>
  );
}
